module.exports = __webpack_public_path__ + "img/jixiaolan.3313d65d.jpg";